import SmallDetails from "components/SmallDetails/SmallDetails";
import moment from "moment";
import classNames from "classnames";
import React from "react";
import { formatOverDue, formatWrittenDayMonthYear } from "utilities";

interface DueProps {
  lifeCycle: server.dto.DocumentLifeCycles
  dueInDays: number
  sendDate: Date
}

export const Due = (props: DueProps) => {
  const { lifeCycle } = props;

  if (lifeCycle === "review") {
    const dueMoment = moment(site.localNow).add(props.dueInDays, "days");
    const dueInText = props.dueInDays === 1
      ? `${RESX.DateTime.lblIn} ${RESX.DateTime.YDay}`
      : `${RESX.DateTime.lblIn} ${props.dueInDays} ${RESX.DateTime.days}`;

    return <SmallDetails
      label={formatWrittenDayMonthYear(dueMoment)}
      subLabel={dueInText}
    />
  }

  const sendMoment = moment(props.sendDate);
  const dueMoment = moment(sendMoment).add(props.dueInDays, "days");
  const localMoment = moment(site.localNow);
  const dueNowDiff = localMoment.diff(dueMoment, "days");

  const isOverDue = dueMoment < localMoment;

  const dueClasses = classNames({
    s1_red: isOverDue
  });

  return <SmallDetails
    label={<span className={dueClasses}>{formatWrittenDayMonthYear(dueMoment)}</span>}
    subLabel={isOverDue ? formatOverDue(dueNowDiff) : undefined}
  />
}